import { memo } from "react";
import PropTypes from "prop-types";

import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SoftBox from "components/SoftBox";

function ViewButtons({ setView, view, setFlowView }) {
  const isListView = view === 1;

  return (
    <SoftBox
      className="table-view-buttons"
      display="flex"
      gap={1}
      justifyContent={{ xs: "space-evenly", xl: "flex-start" }}
    >
      <Tooltip title="List View" placement="top">
        <IconButton
          className={isListView ? "active" : ""}
          variant="text"
          size="medium"
          color="text"
          sx={{
            color: isListView && "#69748C",
            backgroundColor: isListView && "#C7CCD0",
            borderRadius: "10px",
          }}
          onClick={() => {
            setFlowView && setFlowView(1);
            setView(1);
          }}
          data-testid="listBtn"
        >
          <Icon>view_list_icon</Icon>
        </IconButton>
      </Tooltip>
      <Tooltip title="Tiles View" placement="top">
        <IconButton
          className={!isListView ? "" : "active"}
          variant="text"
          size="medium"
          color="text"
          sx={{
            color: !isListView && "#69748C",
            backgroundColor: !isListView && "#C7CCD0",
            borderRadius: "10px",
          }}
          onClick={() => {
            setFlowView && setFlowView(2);
            setView(2);
          }}
          data-testid="tilesBtn"
        >
          <Icon>apps_icon</Icon>
        </IconButton>
      </Tooltip>
    </SoftBox>
  );
}

ViewButtons.propTypes = {
  setView: PropTypes.func,
  view: PropTypes.number,
};

export default memo(ViewButtons);
